var React = require('react');

function BannerShape1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M596 0.000732422L-2.82696e-05 0.000723491L-6.10352e-05 323.367L596 0.0375977L596 0.000732422Z","fill":"#444444","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M-5.00214e-07 151.93L80.732 195.727L80.732 475.883L-5.00209e-07 432.086L-5.00214e-07 151.93Z","fill":"#BBBBBB","key":1})]);
}

BannerShape1.defaultProps = {"width":"596","height":"476","viewBox":"0 0 596 476","fill":"none"};

module.exports = BannerShape1;

BannerShape1.default = BannerShape1;
